import React from "react";
import Slider from "react-styled-carousel";
import { DotBlueGray } from "src/layouts/Default";
import useMedia from "use-media";
import { LeftArrow, RightArrow } from "./styles";
function Carroussel({ list }) {
  const responsive = [
    { breakPoint: 1100, cardsToShow: 3 },
    { breakPoint: 768, cardsToShow: 2 },
    { breakPoint: 0, cardsToShow: 1 },
  ];
  const isMobile = useMedia({ maxWidth: 768 });
  return (
    <Slider
      draggable={false}
      showArrows
      showDots={isMobile}
      autoSlide={false}
      responsive={responsive}
      ssr
      infinite={false}
      autoPlay={false}
      Dot={<DotBlueGray />}
      keyBoardControl
      LeftArrow={
        <LeftArrow src="/gwmbrasil/assets/chevron-left-turquoise.png" />
      }
      RightArrow={
        <RightArrow src="/gwmbrasil/assets/chevron-right-turquoise.png" />
      }
      padding="0"
    >
      {list}
    </Slider>
  );
}

export default Carroussel;
